/**
 * Directive: dateTimePicker
 */
angular.module('acme.common.directive.dateTimePicker', [
  'acme.common.directive.datePicker',
  'acme.common.directive.timePicker'
])
.directive('dateTimePicker', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/dateTimePicker/dateTimePicker.tpl.html',
      scope: {
        time: '=',
        hour: '=',
        minute: '=',
        ampm: '=',
        typeLabel: '@typelabel',
        dateTimePickerIndex: '@datetimepickerindex'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.dateTimePicker = {

          init: function() {}

        };

      }]

    };

}]);